import React, { createContext, ReactNode, useContext, useState } from 'react';

export interface HistoryContext {
  historyId: number | null;
  setHistoryId: (id: number | null) => void;
}

const HistoryContextContext = createContext<HistoryContext>({
  historyId: null,
  setHistoryId: () => {},
});

export function useHistory() {
  return useContext(HistoryContextContext);
}

export function HistoryProvider({ children }: { children: ReactNode }) {
  const [historyId, setHistoryId] = useState<number | null>(null);

  return (
    <HistoryContextContext.Provider value={{ historyId, setHistoryId }}>{children}</HistoryContextContext.Provider>
  );
}
